import { useState } from "react";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { toast } from "sonner";
import { User as UserIcon, Lock } from "lucide-react";
import Layout from "../components/Layout";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function MiPerfil({ user, onLogout }) {
  const [profileData, setProfileData] = useState({
    nombre: user.nombre,
    telefono: user.telefono || ""
  });
  const [profileLoading, setProfileLoading] = useState(false);
  
  const [passwordData, setPasswordData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: ""
  });
  const [passwordLoading, setPasswordLoading] = useState(false);

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setProfileLoading(true);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${API}/users/profile/me`,
        profileData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Update local user data
      const updatedUser = { ...user, ...response.data };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      
      toast.success("Perfil actualizado exitosamente");
    } catch (error) {
      toast.error("Error al actualizar perfil");
    } finally {
      setProfileLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    
    if (passwordData.new_password !== passwordData.confirm_password) {
      toast.error("Las contraseñas no coinciden");
      return;
    }

    if (passwordData.new_password.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    setPasswordLoading(true);

    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API}/users/profile/change-password`,
        passwordData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success("Contraseña cambiada exitosamente");
      setPasswordData({
        current_password: "",
        new_password: "",
        confirm_password: ""
      });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al cambiar contraseña");
    } finally {
      setPasswordLoading(false);
    }
  };

  const getRolLabel = (rol) => {
    return rol === "maestro" ? "Maestro" : rol === "admin" ? "Administrador" : "Propietario";
  };

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="max-w-3xl mx-auto space-y-6 fade-in">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Mi Perfil</h1>
          <p className="text-gray-500 mt-1">Gestiona tu información personal</p>
        </div>

        {/* Profile Info */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <UserIcon className="w-5 h-5" />
              Información Personal
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleUpdateProfile} className="space-y-4">
              <div className="space-y-2">
                <Label>Nombre completo</Label>
                <Input
                  value={profileData.nombre}
                  onChange={(e) => setProfileData({ ...profileData, nombre: e.target.value })}
                  placeholder="Juan Pérez"
                />
              </div>

              <div className="space-y-2">
                <Label>Email</Label>
                <Input
                  type="email"
                  value={user.email}
                  disabled
                  className="bg-gray-100"
                />
                <p className="text-xs text-gray-500">El email no se puede modificar</p>
              </div>

              <div className="space-y-2">
                <Label>Teléfono</Label>
                <Input
                  value={profileData.telefono}
                  onChange={(e) => setProfileData({ ...profileData, telefono: e.target.value })}
                  placeholder="5551234567"
                />
              </div>

              <div className="space-y-2">
                <Label>Rol</Label>
                <Input
                  value={getRolLabel(user.rol)}
                  disabled
                  className="bg-gray-100"
                />
              </div>

              <Button type="submit" disabled={profileLoading}>
                {profileLoading ? "Guardando..." : "Guardar Cambios"}
              </Button>
            </form>
          </CardContent>
        </Card>

        {/* Change Password */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Lock className="w-5 h-5" />
              Cambiar Contraseña
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleChangePassword} className="space-y-4">
              <div className="space-y-2">
                <Label>Contraseña actual</Label>
                <Input
                  type="password"
                  value={passwordData.current_password}
                  onChange={(e) => setPasswordData({ ...passwordData, current_password: e.target.value })}
                  placeholder="••••••••"
                />
              </div>

              <div className="space-y-2">
                <Label>Nueva contraseña</Label>
                <Input
                  type="password"
                  value={passwordData.new_password}
                  onChange={(e) => setPasswordData({ ...passwordData, new_password: e.target.value })}
                  placeholder="••••••••"
                />
              </div>

              <div className="space-y-2">
                <Label>Confirmar nueva contraseña</Label>
                <Input
                  type="password"
                  value={passwordData.confirm_password}
                  onChange={(e) => setPasswordData({ ...passwordData, confirm_password: e.target.value })}
                  placeholder="••••••••"
                />
              </div>

              <Button type="submit" disabled={passwordLoading}>
                {passwordLoading ? "Cambiando..." : "Cambiar Contraseña"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
